module.exports = __webpack_public_path__ + "static/media/Barlow-MediumItalic.4257d524.ttf";